const navItems = [
  {
    href: "#about",
    page: "/",
    texts: "about",
    className: "pictures",
  },
  {
    href: "#values",
    page: "/",
    texts: "values",
    className: "values",
  },
  {
    href: "#services",
    page: "/",
    texts: "services",
    className: "services",
  },
  {
    href: "#contact",
    page: "/",
    texts: "contact",
    className: "contact",
  },
  {
    href: "/partners",
    page: "/partners",
    texts: "partners",
    className: "partners",
  },
];

export default navItems;
